import { mainApi } from "api";
import MainApiRoutes from "const/MainApiRoutes";

export default class IntercomActions {
  static FETCH_USER_JWT_START = "intercom/FETCH_USER_JWT_START";

  static FETCH_USER_JWT_DONE = "intercom/FETCH_USER_JWT_DONE";

  static FETCH_USER_JWT_ERROR = "intercom/FETCH_USER_JWT_ERROR";

  static fetchUserJwt() {
    return async(dispatch) => {
      dispatch({ type: IntercomActions.FETCH_USER_JWT_START });

      const { INTERCOM, USER_JWT } = MainApiRoutes;

      const { result: userJwt } = await mainApi.get(INTERCOM + USER_JWT);

      if (userJwt) {
        dispatch({ type: IntercomActions.FETCH_USER_JWT_DONE, payload: { userJwt } });

        return userJwt;
      }
      dispatch({ type: IntercomActions.FETCH_USER_JWT_ERROR });

      return null;
    };
  }
}
